import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('shipment-customer-phone', () => import(/* webpackMode: "lazy" */'./shipment-customer-phone'));
